<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-list subheader three-line>
      <v-subheader>Agent Controller</v-subheader>

      <v-layout justify-center>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="bookingAgent" color="#00C853"></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Booking Agent </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ bookingAgent ? "Booking Agent on" : "Booking Agent off" }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md4 class="scrolling-wrapper">
          <v-list-tile>
            <v-list-tile-action>
              <v-container fluid>
                <v-layout v-for="(subcompany, i) in subcompanies" :key="i">
                  <v-checkbox
                    v-model="subcompany_list"
                    color="teal"
                    :label="subcompany.text"
                    :value="subcompany.value"
                  ></v-checkbox>
                </v-layout>
              </v-container>
            </v-list-tile-action>
          </v-list-tile>
        </v-flex>
      </v-layout>
    </v-list>
  </v-form>
</template>

<script>
export default {
  props: {
    data: Object,
    subcompanies: Array
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        booking_agent: this.bookingAgent ? 1 : 0,
        sub_companies: this.subcompany_list
      };
    },
    tripmanifest() {
      if (
        this.data.trip_manifest_status === 1 ||
        this.data.trip_manifest_status === true
      ) {
        return true;
      } else {
        return false;
      }
    },
    dispatcherStatus: {
      get() {
        return this.data.dispatcher_status;
      },
      set(value) {
        this.data.dispatcher_status = value;

        this.data.teller_status = 0;
      }
    },
    tellerStatus: {
      get() {
        return this.data.teller_status;
      },
      set(value) {
        this.data.teller_status = value;

        this.data.dispatcher_status = 0;
        this.data.conductor_status = 0;
      }
    }
  },
  data() {
    return {
      valid: true,
      rules: {
        required: value => !!value || "This field is required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        number: value => !isNaN(value) || "Must be number.",
        minFloor: value => value >= 1 || "The minimum number is 1.",
        maxFloor: value => value <= 30 || "The maximum number is 30."
        // minRow: value => value >= 10 || "The minimum row is 10",
        // maxRow: value => value <= 15 || "The maximum row is 15.",
        // minColumn: value => value >= 4 || "The minimum row is 4.",
        // maxColumn: value => value <= 7 || "The maximum row is 7."
      },
      bookingAgent: this.data.booking_agent ? true : false,
      subcompany_list: this.data.sub_companies ? this.data.sub_companies : []
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    }
  }
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  height: 200px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>